import React from 'react';
import { vnDateTime } from '../configs';
import Moment from 'react-moment';


export default function StepItemCard({ item, columnColor, onEdit, user, numberStar = 5 }) {
    const files = item.list_file_decoded || [];

    const loopStar = () => {
        const elements = [];
        const currentStar = item.ratings ? parseInt(item.ratings) : 0;
        const activeStar = currentStar;

        for (let i = 1; i <= numberStar; i++) {
            elements.push(
                <span key={i} style={{ fontSize: 20 }} className={i <= activeStar ? "fas fa-star text-warning" : "far fa-star text-warning"}></span>
            );
        }
        return <div className="d-flex">{elements}</div>;
    };

    return (
        <div
            className="card mb-3 border-0 shadow-sm item-kanban-card hvr-float"
            style={{ borderRadius: '8px', cursor: 'pointer' }}
            onClick={() => onEdit && onEdit(item)}
        >
            <div className="card-body p-3">
                {/* Header của Card: Hiển thị tên Mission cha */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <span
                        className="badge badge-light text-muted border-left"
                        style={{
                            fontSize: '10px',
                            borderLeft: `3px solid ${columnColor || '#ccc'}`,
                            paddingLeft: '8px'
                        }}
                    >
                        <i className="fas fa-layer-group mr-1"></i>
                        {item.tags}
                    </span>

                    <button
                        className="btn btn-xs text-muted p-0"
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation(); // Ngăn chặn sự kiện click vào card
                            onEdit(item);
                        }}
                    >
                        <i className="fas fa-ellipsis-h"></i>
                    </button>
                </div>

                <h6
                    className="mb-1 text-dark"
                    style={{ fontSize: '14px', fontWeight: '600', lineHeight: '1.4' }}
                >
                    {item.title}
                </h6>
                {item.description && (
                    <p
                        className="small text-muted mb-2 text-truncate-2"
                        style={{ fontSize: '12px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
                    >
                        {item.description}
                    </p>
                )}
                {item.time_received && <p className='w-100 d-flex align-items-center text-primary'>
                    <span className='far fa-clock'></span><small className='ml-2'>Bắt đầu lúc: {vnDateTime(item.time_received)}</small>
                </p>}
                {item.time_expected_completion && <p className='w-100 d-flex align-items-center text-info'>
                    <span className='fas fa-long-arrow-alt-right'></span><small className='ml-2'>Dự kiến:<Moment format="DD/MM/YYYY">{new Date(item.time_expected_completion)}</Moment></small>
                </p>}
                {item.time_finish && <p className='w-100 d-flex align-items-center text-success'>
                    <span className='fas fa-clipboard-check'></span><small className='ml-2'>Hoàn thành: {vnDateTime(item.time_finish)}</small>
                </p>}
                {item.status == 3 ? <div className='w-100 mt-2'>{loopStar()}</div> : ''}
                <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <div className="d-flex align-items-center">
                        <div className="p-1 bg-info rounded text-white shadow-sm " style={{ fontSize: '12px',fontWeight: 'bold' }}>
                            <span className='fas fa-user-edit'></span> {item.author_email} 
                        </div>
                        {files.length > 0 && (
                            <div className="badge badge-pill badge-primary-light text-primary ml-1" style={{ fontSize: '12px' }}>
                                <i className="fas fa-paperclip mr-1"></i>
                                {files.length}
                            </div>
                        )}
                    </div>
                    <span className='fas fa-long-arrow-alt-right'></span>
                    <div
                        className={"p-1 bg-info rounded text-white shadow-sm " + (item.user_id == user.data.id ? "bg-danger" : "bg-info")}
                        style={{ fontSize: '12px', fontWeight: 'bold' }}
                        title={item.fullname || 'Chưa giao việc'}
                    >
                        {item.fullname
                            ? <><span className='fas fa-flag-checkered'></span> {item.email_alias}</>
                            : <><i className="fas fa-user-slash" style={{ fontSize: '8px' }}></i> Chưa giao việc</>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};
